import _ from 'lodash'
import { List, Map, isImmutable } from 'immutable'
import { LAYOUT_MODE } from '../constants/toUnits'
import { TAB_TYPES } from './tab-utils'
import { getColumnSubPath } from './powerTableUtils'

export function processApplyOnloadACRules(state, isOnLogin, customPages) {
  if (state.getIn(['project', 'Settings', 'ac', 'enabled'])) {
    const rules = state.getIn(['project', 'Settings', 'ac', 'list'], List())
    let role = Map()
    let guestRule, targetRule, fallback
    const smartvParamID =
      state
        .getIn(['project', 'params'], List())
        .find((param) => param.get('isACParam') === true)
        ?.get?.('id') || '_'
    const smartvParameterValue = smartvParamID ? state.getIn(['params', smartvParamID], '') : ''
    rules.map((rule) => {
      if (rule.get('isFallback') && rule.get('enabled')) {
        fallback = rule
      } else if (rule.get('isUnidentified') && rule.get('enabled')) {
        guestRule = rule
      } else if (rule.get('enabled') && smartvParameterValue) {
        if (rule.get('value') == smartvParameterValue) {
          targetRule = rule
        }
      }
    })
    if (targetRule) {
      role = targetRule
    } else {
      if (smartvParameterValue) {
        if (fallback) {
          role = fallback
        }
      } else {
        if (guestRule) {
          role = guestRule
        }
      }
    }

    if (role.get('enabled')) {
      rules.map((row) => {
        if (row && row.get('enabled') && row.get('id') != role.get('id')) {
          row.get('rules', Map()).map((value, key) => {
            if (isImmutable(value)) {
              value.map((val, subKey) => {
                if (!role.getIn(['rules', key, subKey])) {
                  role = role.setIn(['rules', key, subKey], '')
                }
              })
            }
          })
        }
      })

      let roleRules = role.get('rules', Map())
      let retState = applyProjectRules(state, roleRules)
      if (isOnLogin) {
        state.get('pages', Map()).map((val, pageID) => {
          retState = applyPageRules(retState, pageID, roleRules)
        })
        return retState
      } else if (customPages) {
        _.each(customPages, function (val, pageID) {
          retState = applyPageRules(retState, pageID, roleRules)
        })
        return retState
      } else {
        return applyPageRules(retState, state.get('page'), roleRules)
      }
    }
  }
  return state
}

export function applyProjectRules(state, rules) {
  const processElements = state
    .getIn(['project', 'Settings', 'elements'], Map())
    .reduce((r, v, k) => r.push(k), List())
    .toJS()
  let processedState = state

  _.each(processElements, (uid) => {
    processedState = applyRule(processedState, ['project', 'Settings', 'elements', uid], rules)
  })

  state.getIn(['project', 'params'], List()).map((param, index) => {
    const rule = rules.getIn([param.get('id'), 'valueState'])
    if (rule === 'readonly') {
      processedState = processedState
        .setIn(['project', 'params', index, 'origin'], param.get('origin', param.get('isReadOnly')))
        .setIn(['project', 'params', index, 'isReadOnly'], true)
    } else {
      processedState = processedState.setIn(
        ['project', 'params', index, 'isReadOnly'],
        param.get('origin', param.get('isReadOnly'))
      )
    }
  })

  // if (state.getIn(['project', 'Settings', 'Header', 'enable'], false)) {
  //     rules.map((value, key) => {
  //         if (['Menu', 'UserMenu'].includes(key)) {
  //             processedState = applyHeaderRule(processedState, key, value)
  //         } else if (_.startsWith(key, 'Header:')) {
  //             processedState = applyHeaderRule(processedState, key, value)
  //         }
  //     })
  // }

  return processedState
}

export function applyPageRules(state, pageID, rules) {
  if (!state.getIn(['pages', pageID], Map())) {
    return state
  }

  const processElements = state
    .getIn(['pages', pageID, 'Props', 'elements'], Map())
    .reduce((r, v, k) => r.push(k), List())
    .toJS()
  let processedState = state

  _.each(processElements, (uid) => {
    processedState = applyRule(processedState, ['pages', pageID, 'Props', 'elements', uid], rules)
  })

  state.getIn(['pages', pageID, 'Props', 'params'], List()).map((param, index) => {
    const rule = rules.getIn([param.get('id'), 'valueState'])
    if (rule === 'readonly') {
      processedState = processedState
        .setIn(['pages', pageID, 'Props', 'params', index, 'origin'], param.get('origin', param.get('isReadOnly')))
        .setIn(['pages', pageID, 'Props', 'params', index, 'isReadOnly'], true)
    } else {
      processedState = processedState.setIn(
        ['pages', pageID, 'Props', 'params', 'params', index, 'isReadOnly'],
        param.get('origin', param.get('isReadOnly'))
      )
    }
  })

  return processedState
}

const getHeaderMenuItemKey = (key, state) => {
  let keyPath = _.tail(String(key).split(':'))
  if (keyPath.length === 2) {
    const index = state
      .getIn(['project', 'Settings', 'Header', 'Menu'], List())
      .findIndex((menu) => menu.get('id') === keyPath[0])
    if (index !== -1) {
      const childIndex = state
        .getIn(['project', 'Settings', 'Header', 'Menu', index, 'children'], List())
        .findIndex((menu) => menu.get('id') === keyPath[1])
      if (childIndex !== -1) {
        return ['Menu', index, 'children', childIndex, 'show']
      }
    }
  } else if (keyPath.length === 1) {
    const index = state
      .getIn(['project', 'Settings', 'Header', 'Menu'], List())
      .findIndex((menu) => menu.get('id') === keyPath[0])
    if (index !== -1) {
      return ['Menu', index, 'show']
    }
  }
  return ['__']
}

const applyHeaderRule = (state, key, rulesToApply) => {
  let processedState = state

  rulesToApply.map((rule, ruleName) => {
    switch (ruleName) {
      case 'visibility':
        if (['Menu', 'UserMenu'].includes(key)) {
          _.each(LAYOUT_MODE, (mode) => {
            const path = ['project', 'Settings', 'Header', mode, `isHidden${key}`]
            if (rule === 'hidden') {
              processedState = processedState.setIn(path, true)
            } else if (rule === 'visible' || rule === '') {
              processedState = processedState.setIn(path, false)
            }
          })
        } else {
          const path = ['project', 'Settings', 'Header', ...getHeaderMenuItemKey(key, processedState)]
          if (rule === 'hidden') {
            processedState = processedState.setIn(path, false)
          } else if (rule === 'visible' || rule === '') {
            processedState = processedState.setIn(path, true)
          }
        }
        break
    }
  })

  return processedState
}

export const applyRule = (state, path, rules) => {
  const rulesToApply = rules.get(_.last(path), Map())
  const colTabRules = rules.filter(
    (v, k) => String(k).includes(`${_.last(path)}:`) || String(k).includes(`:${_.last(path)}`)
  )
  const stripRules = rules.filter((v, k) => String(k).includes(`---`))
  let processedState = state

  const processRule =
    (path, isCustom = false, type, ruleKey) =>
    (rule, ruleName) => {
      switch (ruleName) {
        case 'visibility': {
          const tabID = _.last(String(ruleKey).split(':'))
          _.each(LAYOUT_MODE, (mode) => {
            if (isCustom && ['table', 'list'].includes(type)) {
              if (rule === 'hidden') {
                processedState = processedState.setIn(
                  _.initial(path),
                  processedState.getIn(_.initial(path), List()).filter((col) => col.get('id') !== tabID)
                )
              } else if (!rule && rule === 'visible') {
                processedState = processedState.setIn([...path, 'show', mode], true)
              }
            } else if (isCustom && TAB_TYPES.includes(type)) {
              let tabs = processedState.getIn([...path, 'props', mode, 'tabs'], List())
              if (rule === 'hidden') {
                if (tabs && tabs.size > 0) {
                  processedState = processedState.setIn(
                    [...path, 'props', mode, 'tabs'],
                    tabs.filter((tab) => tab.get('id') !== tabID)
                  )
                }
              } else if (!rule && rule === 'visible') {
                const index = tabs.findIndex((v) => v.get('id') === tabID)
                if (index !== -1) {
                  processedState = processedState.setIn([...path, 'props', mode, 'tabs', index, 'hide'], false)
                }
              }
            } else if (isCustom && type === 'PowerTable') {
              if (rule === 'hidden') {
                processedState = processedState
                  .setIn([...path, 'isVisible'], false)
                  .setIn([...path, 'meta', 'hideCol'], true)
              } else if (!rule || rule === 'visible') {
                processedState = processedState
                  .setIn([...path, 'isVisible'], true)
                  .setIn([...path, 'meta', 'hideCol'], false)
              }
            }
          })
          break
        }
        case 'ptColEdit':
          if (!rule) {
            if (processedState.getIn([...path, 'meta', 'defaultAllowEdit']) !== undefined) {
              processedState = processedState.setIn(
                [...path, 'meta', 'allowEdit'],
                processedState.getIn([...path, 'meta', 'defaultAllowEdit'], false)
              )
            }
          } else if (rule === 'disabled') {
            if (processedState.getIn([...path, 'meta', 'defaultAllowEdit']) === undefined) {
              processedState = processedState.setIn(
                [...path, 'meta', 'defaultAllowEdit'],
                processedState.getIn([...path, 'meta', 'allowEdit'], false)
              )
            }
            processedState = processedState.setIn([...path, 'meta', 'allowEdit'], false)
          } else if (rule === 'enabled') {
            if (processedState.getIn([...path, 'meta', 'defaultAllowEdit']) === undefined) {
              processedState = processedState.setIn(
                [...path, 'meta', 'defaultAllowEdit'],
                processedState.getIn([...path, 'meta', 'allowEdit'], false)
              )
            }
            processedState = processedState.setIn([...path, 'meta', 'allowEdit'], true)
          }
          break
        case 'ptQuickUpdate':
          if (!rule) {
            if (processedState.getIn([...path, 'meta', 'defaultAllowBulkUpdate']) !== undefined) {
              processedState = processedState.setIn(
                [...path, 'meta', 'allowBulkUpdate'],
                processedState.getIn([...path, 'meta', 'defaultAllowBulkUpdate'], false)
              )
            }
          } else if (rule === 'disabled') {
            if (processedState.getIn([...path, 'meta', 'defaultAllowBulkUpdate']) === undefined) {
              processedState = processedState.setIn(
                [...path, 'meta', 'defaultAllowBulkUpdate'],
                processedState.getIn([...path, 'meta', 'allowBulkUpdate'], false)
              )
            }
            processedState = processedState.setIn([...path, 'props', 'allowBulkUpdate'], false)
          } else if (rule === 'enabled') {
            if (processedState.getIn([...path, 'meta', 'defaultAllowBulkUpdate']) === undefined) {
              processedState = processedState.setIn(
                [...path, 'meta', 'defaultAllowBulkUpdate'],
                processedState.getIn([...path, 'meta', 'allowBulkUpdate'], false)
              )
            }
            processedState = processedState.setIn([...path, 'props', 'allowBulkUpdate'], true)
          }
        case 'state':
          _.each(LAYOUT_MODE, (mode) => {
            if (isCustom && TAB_TYPES.includes(type)) {
              const tabID = _.last(String(ruleKey).split(':'))
              let tabs = processedState.getIn([...path, 'props', mode, 'tabs'], List())
              const index = tabs.findIndex((v) => v.get('id') === tabID)
              if (index !== -1) {
                if (rule === 'disabled') {
                  processedState = processedState.setIn([...path, 'props', mode, 'tabs', index, 'disabled'], true)
                } else if (!rule || rule === 'enabled') {
                  processedState = processedState.setIn([...path, 'props', mode, 'tabs', index, 'disabled'], false)
                }
              }
            } else {
              if (rule === 'disabled') {
                processedState = processedState.setIn([...path, 'props', mode, 'isDisabled'], true)
              } else if (!rule || rule === 'enabled') {
                processedState = processedState.setIn([...path, 'props', mode, 'isDisabled'], false)
              }
            }
          })
          break
        case 'valueState':
          _.each(LAYOUT_MODE, (mode) => {
            if (rule === 'readonly') {
              processedState = processedState.setIn([...path, 'props', mode, 'readOnly'], true)
              // .setIn([...path, 'props', mode, 'isDisabled'], true)
            } else if (!rule || rule === 'enabled') {
              processedState = processedState.setIn([...path, 'props', mode, 'readOnly'], false)
              // .setIn([...path, 'props', mode, 'isDisabled'], false)
            }
            if (rule === 'disabled') {
              processedState = processedState.setIn([...path, 'props', mode, 'isDisabled'], true)
            } else if (!rule || rule === 'enabled') {
              processedState = processedState.setIn([...path, 'props', mode, 'isDisabled'], false)
            }
          })
          break
      }
    }

  rulesToApply.map(processRule(path))
  colTabRules.map((rules, ruleKey) => {
    let isProccess = true
    let rulePath = [...path]
    const elem = processedState.getIn(path, Map())
    let type = elem.get('type')
    switch (elem.get('type')) {
      case 'Widget':
        let key = 'mapping'
        type = elem.getIn(['props', 'data', 'Type'])
        switch (elem.getIn(['props', 'data', 'Type'])) {
          case 'list':
            key = 'columns'
          case 'table':
            const colID = _.last(String(ruleKey).split(':'))
            const colIndex = elem.getIn(['props', 'data', 'Props', key], List()).findIndex((v) => v.get('id') === colID)
            if (colIndex !== -1) {
              rulePath = [...rulePath, 'props', 'data', 'Props', key, colIndex]
              isProccess = true
            } else {
              isProccess = false
            }
            break
        }
        break
      case 'PowerTable': {
        const colID = String(ruleKey).split(':')[1]
        const columns = elem.getIn(['props', 'columns'], List()).toJS()
        const path = getColumnSubPath(columns, colID)
        rulePath = [...rulePath, 'props', 'columns', ...path]
        break
      }
    }
    // console.log('>>>', rulePath, ruleKey, rules.toJS(), isProccess)
    if (isProccess && Map.isMap(rules)) {
      rules.map(processRule(rulePath, true, type, ruleKey))
    }
  })
  stripRules.map((rule, key) => {
    const [id, col] = String(key).split('---')
    if (Map.isMap(rule)) {
      processedState = processedState.setIn(
        [..._.initial(path), id, 'props', 'isInvisibleCol', col],
        rule.get('visibility') === 'hidden'
      )
    }
  })
  return processedState
}
